import { createAsyncThunk } from '@reduxjs/toolkit';
import { IState } from '../..';
import { httpService } from '../../..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { executeApiRequest } from '../../asyncUtils';
import { processMessagesThunk, showFailedRequestDialogThunk } from '../../thunkUtils';
import { uiActionCreators } from '../../ui';
import { logisticsActionCreators } from '../logisticsActionCreators';
import { ILoad, ILoadApiResponse } from '../logisticsInterfaces';

export const updateActualTotal = createAsyncThunk<void, ILoad, { state: IState }>(
  'logistics/updateActualTotal',
  async (load, { dispatch, getState }) => {
    dispatch(uiActionCreators.showSpinnerDialog());
    const response = await executeApiRequest<IEntityWithMessages<ILoadApiResponse>>(() =>
      httpService.post(`/Logistics/Loads/${load.loadNumber}/ActualTotal`, load)
    );

    if (response.requestFailed) {
      showFailedRequestDialogThunk(response, getState(), dispatch);
    } else if (response.value) {
      processMessagesThunk({ response: response.value, dispatch });

      if (response.value.value) {
        dispatch(logisticsActionCreators.setLoad(response.value.value));
      }
    }

    dispatch(uiActionCreators.hideSpinnerDialog());
  }
);
